import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from '@/components/molecules/skeletons';
import { SKELETON } from '@/lib/constants';
import { PageContainer } from '@/components/templates/PageContainer';

export const CourseAdminPageSkeleton = memo(function CourseAdminPageSkeleton() {
  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        {/* Matches Course.tsx workspace-mode offset — see Course.tsx comment. */}
        <div className="flex h-[calc(100vh-124px)] border border-border/20 rounded-xl overflow-hidden">
          {/* Left panel (30%) */}
          <div className="w-[30%] border-r border-border/20 p-3 space-y-3">
            <Skeleton className="h-8 w-full rounded-md" />
            <Skeleton className="h-8 w-full rounded-md" />
            {Array.from({ length: SKELETON.SUBJECT_LIST_ITEMS }).map((_, i) => (
              <Skeleton key={i} className="h-14 w-full rounded-md" />
            ))}
          </div>
          {/* Right panel (70%) */}
          <div className="flex-1 p-6 space-y-4">
            <Skeleton className="h-10 w-48 rounded-md" />
            <Skeleton className="h-64 w-full rounded-lg" />
          </div>
        </div>
      </div>
    </PageContainer>
  );
});
